import * as React from 'react';
import { Notification } from './NotificationContext';
import { Alert, Box, Span } from '@kite-js/core';
import { CSSTransition } from 'react-transition-group';
import { BoxProps } from '@kite-js/core/lib/Box/Box';
import { ControlLineCloseFilledIcon } from '@kite-js/icons';

type SlidingNotification = {
    wrapper: BoxProps;
    slideFromTop: boolean;
    notification?: Notification;
    handleDismiss?: () => void;
};

export const SlidingNotification: React.FC<SlidingNotification> = (props: SlidingNotification) => {
    const { wrapper, slideFromTop, notification, handleDismiss } = props;
    const wrapperProps: BoxProps = slideFromTop
        ? { ...wrapper, position: 'fixed', width: '100%', top: '0', left: '0' } // Notif will always be at top
        : wrapper;

    return (
        <CSSTransition
            key="notification"
            // tslint:disable-next-line
            addEndListener={(node, done) => {
                node.addEventListener('transitionend', done, false);
            }}
            classNames={slideFromTop ? 'slide' : 'enter'}
            timeout={500}
            in={!!notification}
        >
            <>
                {
                    // tslint:disable-next-line: jsx-no-multiline-js
                    !!notification && (
                        <Box {...wrapperProps} data-cy="notification-container">
                            <Alert
                                color={notification.color === 'info' ? 'notice' : notification.color}
                                icon={notification.icon}
                                message={
                                    <Box
                                        display="flex"
                                        flexWrap="nowrap"
                                        justifyContent="space-between"
                                        alignItems="center"
                                        width="100%"
                                    >
                                        <Box display="block">
                                            <Span
                                                {...(!!notification.testId ? { 'data-cy': notification.testId } : {})}
                                            >
                                                {notification.messeageJsx
                                                    ? notification.messeageJsx
                                                    : notification.message}
                                            </Span>
                                            {
                                                // tslint:disable-next-line: jsx-no-multiline-js
                                                notification.link && <Box mt="M">{notification.link}</Box>
                                            }
                                        </Box>

                                        {
                                            // tslint:disable-next-line: jsx-no-multiline-js
                                            // tslint:disable-next-line: jsx-wrap-multiline
                                            handleDismiss && (
                                                <Box mx="S" clone={true}>
                                                    <ControlLineCloseFilledIcon
                                                        data-cy="dismiss-notification-icon"
                                                        size="M"
                                                        onClick={handleDismiss}
                                                    />
                                                </Box>
                                            )
                                        }
                                    </Box>
                                }
                                data-cy="notification"
                            />
                        </Box>
                    )
                }
            </>
        </CSSTransition>
    );
};
